import React from "react";
import Lottie from "lottie-react";
import loadingAnimation from "../assets/images/loading.json";

const Loading = ({ message = "Loading" }) => {
  // Define keyframe animation for pulsing opacity and blinking dot
  const pulseAnimation = {
    animation: "pulse 1.5s infinite",
  };

  const blinkingDotStyle = {
    display: "inline-block",
    marginLeft: 5,
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "#2d3748",
    animation: "blink 1.5s infinite",
  };

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          @keyframes blink {
            0%, 50%, 100% { opacity: 1; }
            25%, 75% { opacity: 0; }
          }
        `}
      </style>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
          textAlign: "center",
          padding: "1rem",
          color: "#4a5568",
          fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        <div style={{ width: 200 }}>
          <Lottie animationData={loadingAnimation} loop={true} />
        </div>
        <p
          style={{
            marginTop: "1rem",
            fontSize: "2rem",
            fontWeight: 500,
            color: "#2d3748",
            ...pulseAnimation,
          }}
        >
          {message}
          <span style={blinkingDotStyle}></span>
          <span style={blinkingDotStyle}></span>
          <span style={blinkingDotStyle}></span>
        </p>
      </div>
    </>
  );
};

export default Loading;
